const MuiLink = {
    defaultProps: {
        color: 'primary',
        underline: 'none'
    },
    styleOverrides: {
        root: ({ theme })=>({
                color: theme.palette.secondary.main
            })
    }
};
export { MuiLink };

//# sourceMappingURL=link.js.map